(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thesaint-editorial"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('thesaint-rail')) {
    customElements.define('thesaint-rail', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.rail = this.querySelector('.ts-rail');
        this.controls = this.querySelector('.ts-rail__controls');
        this.buttons = [...this.querySelectorAll('[data-direction]')];
        this.update = () => {
          const overflow = this.rail.scrollWidth - this.rail.clientWidth;
          this.controls.hidden = overflow < 2;
          const rtl = getComputedStyle(this.rail).direction === 'rtl';
          const position = Math.abs(this.rail.scrollLeft);
          this.buttons[0].disabled = position < 2;
          this.buttons[1].disabled = position >= overflow - 2;
          this.rtl = rtl;
        };
        this.buttons.forEach(button => button.addEventListener('click', () => {
          const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
          const direction = Number(button.dataset.direction) * (this.rtl ? -1 : 1);
          this.rail.scrollBy({ left: direction * this.rail.clientWidth, behavior: reduced ? 'instant' : 'smooth' });
        }, { signal }));
        this.rail.addEventListener('scroll', this.update, { passive: true, signal });
        this.observer = new ResizeObserver(this.update);
        this.observer.observe(this.rail);
        this.update();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
